import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomizeOrdersService } from '../services/customize-order.service';
import { CustomizeOrderModel } from '../models/CustomizeOrderModel';
import { DomSanitizer } from '@angular/platform-browser';
import { ProperityService } from '../services/properity.service';
import { Globals } from "../globals";

@Component({
    selector: 'app-customize-orders-add-modal',
    templateUrl: './customize-orders-add-modal.component.html',
    styleUrls: ['./customize-orders-add-modal.component.css']
})
export class CustomizeOrdersAddModalComponent implements OnInit {

    orderDetails: CustomizeOrderModel = {};
    technicianName = "";
    imageToShow: any;
    isImagLoaded = false;
    sendNotification: boolean = false;
    message: string = "";
    orderItems: string = "";
    orderItemsPrice: string = "";
    orderItemsQuantity: string = "";
    orderPaid: boolean = false;
    newTargetDate: string = "";
    orderItemsArr: any = [];
    rollbackDescription: string = "";
    isAgent: boolean = false;
    newPaidStatus: boolean = false;
    notPaidJustification: string = "";
    newNotPaidJustification: string = "";

    constructor(public dialogRef: MatDialogRef<CustomizeOrdersAddModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private customizeOrdersService: CustomizeOrdersService, private sanitizer: DomSanitizer,
        public globals: Globals, private properityService: ProperityService) { }

    ngOnInit(): void {
        this.orderDetails = this.data.orderDetails;
        this.isAgent = this.data.isAgent;
        this.newTargetDate = this.globals.formateDate(this.orderDetails.targetDate);
        if (this.orderDetails.status == "CS_ITEMS_CONFIRMATION" || this.orderDetails.status == "ASSIGNED" || this.orderDetails.status == "AWAITING_CUSTOMER_CONFIRMATION" ||
            this.orderDetails.status == "CS_COMPLETIION_CONFIRMATION" || this.orderDetails.status == "DONE") {
            this.getOrderItems();
        }
        if (this.orderDetails.status === 'DONE') {
            this.newPaidStatus = this.orderDetails.paid;
            this.newNotPaidJustification = this.orderDetails.notPaidJustification;
        }
        if (this.data) {
            this.getPhoto(this.orderDetails.photo);
            if (this.orderDetails.rate) {
                this.orderDetails.rate = this.orderDetails.rate.length == 2 ? this.orderDetails.rate[1] + " Stars" : this.orderDetails.rate;
            }
        }
    }

    getOrderItems() {
        this.customizeOrdersService.getOrderItems(this.orderDetails.customizedServiceId).subscribe(result => {
            this.orderItemsArr = result;
        });
    }

    getPhoto(path) {
        if (path != "" && path != null) {
            this.customizeOrdersService.getImage(path).subscribe((result: any) => {
                var binary = '';
                var bytes = new Uint8Array(result);
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                let img = window.btoa(binary);
                this.imageToShow = this.sanitizer.bypassSecurityTrustUrl('data:image/jpg;base64, ' + img);
                this.isImagLoaded = true;
            });
        }
    }

    async assignSurveyTechnical() {
        const dataObj = {
            'customizedOrderId': this.orderDetails.customizedServiceId,
            'surveyTechnicianName': this.technicianName,
        };
        this.customizeOrdersService.assignSurveyTechnical(dataObj).subscribe(a => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been assigned successfully");
        });
    }

    assignAndAddItems() {
        var data = {
            "customizedOrderId": this.orderDetails.customizedServiceId,
            "items": this.orderItemsArr,
            "technicianName": this.technicianName
        }
        this.customizeOrdersService.addOrderItems(data).subscribe(result => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been assigned successfully");
        })
    }

    completeOrder() {
        const dataObj = {
            'customizedServiceId': this.orderDetails.customizedServiceId
        };
        this.customizeOrdersService.CompleteOrder(dataObj).subscribe(a => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been completed successfully");
        });
    }

    rollBackOrder() {
        const dataObj = {
            'customizedOrderId': this.orderDetails.customizedServiceId,
            'rollbackDescription': this.rollbackDescription,
            'targetDate': this.orderDetails.targetDate,
            'technician': this.orderDetails.technician
        };
        this.customizeOrdersService.RollBackOrder(dataObj).subscribe(a => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been rollbacked successfully");
        });
    }

    // send() {
    //     if (this.message.length > 255) {
    //         this.globals.presentErrorToast("Message can be max 255 characters");
    //         return false;
    //     }
    //     var data =
    //     {
    //         "message": this.message,
    //         "title": "Customized Orders",
    //         "topic": "Customized Orders"
    //     }
    //     this.properityService.sendMessage(this.orderDetails.userId, data).subscribe(result => {
    //       this.dialogRef.close();
    //       this.globals.presentSuccessToast("Message sent successfully")
    //     });
    // }

    onClickCancel(): void {
        this.dialogRef.close(false);
    }

    confirmAssignSurveyOrder() {
        var data = {
            "customizedOrderId": this.orderDetails.customizedServiceId,
        }
        this.customizeOrdersService.confirmSurveyOrder(data).subscribe(a => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been confirmed successfully");
        });
    }

    confirmAssignOrder() {
        var data = {
            "customizedServiceId": this.orderDetails.customizedServiceId,
        }
        this.customizeOrdersService.confirmAssignOrder(data).subscribe(a => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been confirmed successfully");
        });
    }

    confirmCompleteOrder() {
        var data = {
            "customizedServiceId": this.orderDetails.customizedServiceId,
            "paid": this.orderPaid,
            "notPaidJustification": this.orderPaid ? "" : this.notPaidJustification
        }
        this.customizeOrdersService.confirmCompleteOrder(data).subscribe(a => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been confirmed successfully");
        });
    }

    updateTechName() {
        var data = {
            "customizedOrderId": this.orderDetails.customizedServiceId,
            "technician": this.technicianName
        }
        this.customizeOrdersService.updateOrderTechName(data).subscribe(result => {
            this.globals.presentSuccessToast("Order has been updated successfully");
            this.orderDetails.technician = this.technicianName;
            this.technicianName = "";
        });
    }

    updatePaidStatus() {
        var data = {
            "customizedOrderId": this.orderDetails.customizedServiceId,
            "paid": this.newPaidStatus,
            "notPaidJustification": this.orderDetails.notPaidJustification
        }
        this.customizeOrdersService.updateOrderTechName(data).subscribe(result => {
            this.globals.presentSuccessToast("Order has been updated successfully");
            this.orderDetails.paid = this.newPaidStatus;
            this.dialogRef.close(true);
        });
    }


    updateTargetDate() {
        var data: any = {
            "customizedOrderId": this.orderDetails.customizedServiceId,
            "targetDate": this.globals.formateDate(this.newTargetDate)
        }
        if (this.orderDetails.status === 'CS_SURVEY_CONFIRMATION') {
            data.status = "PENDING";
        }
        this.customizeOrdersService.updateOrderTechName(data).subscribe(result => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been updated successfully");
        });
    }

    cancelOrder() {
        this.customizeOrdersService.cancelOrder(this.orderDetails.customizedServiceId).subscribe(result => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been cancelled successfully");
        });
    }

    confirmOrder() {
        var data = {
            "customizedServiceId": this.orderDetails.customizedServiceId
        };
        this.customizeOrdersService.confirmAddedItems(data).subscribe(result => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been confirmed successfully");
        });
    }

    addItems() {
        this.orderItemsArr.push({ description: this.orderItems, descriptionAr: this.orderItems, price: this.orderItemsPrice, quantity: this.orderItemsQuantity });
        this.orderItems = this.orderItemsPrice = this.orderItemsQuantity = "";
    }

    removeItems(index) {
        this.orderItemsArr.splice(index, 1);
    }
}
